import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';

const Cancel = () => {
  return (
    <MainLayout>
      <Section bg="cream" className="min-h-[60vh] flex items-center">
        <div className="max-w-2xl mx-auto text-center bg-white p-12 rounded-3xl shadow-sm border border-gray-100">
          <h1 className="text-3xl font-bold text-brand-navy mb-4">Checkout Cancelled</h1>
          <p className="text-lg text-gray-600 mb-8">
            No worries! Your order has not been processed. If you had trouble with payment, please contact us.
          </p>
          <Button to="/resources" variant="primary">Return to Resources</Button>
        </div>
      </Section>
    </MainLayout>
  );
};

export default Cancel;